'use client';

import { useEffect } from 'react';
import ErrorState from '@/components/ErrorState';

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <ErrorState
      reset={reset}
      title="Ocorreu um erro inesperado"
      description="Algo correu mal ao carregar esta página. Tenta novamente ou volta ao início."
    />
  );
}
